// --------------------------------------------------------------
// Created On: 2023-06-01
// Author: Zachary Thomas
//
// Last Modified: 2025-07-31
// Modified By: Hannah Vaughan
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Constants related to attributes.
export const LOCATION_ATTRIBUTE = "LocationAttr";
export const GPS_TRAVEL_SPEED_ATTRIBUTE = "GPSMPHAttr";
export const POWER_TO_PANEL_ATTRIBUTE = "PowerToPanelAttr";
export const ENGINE_RUNNING_ATTRIBUTE = "EngineRunningAttr";
export const SUCTION_PRESSURE_ATTRIBUTE = "SuctionPressureAttr";
export const DISCHARGE_PRESSURE_ATTRIBUTE = "DischargePressureAttr";
export const COMMON_ALARM_ATTRIBUTE = "CommonAlarmAttr";
export const RPM_ATTRIBUTE = "RPMAttr";
export const FUEL_RATE = "FuelRateAttr";

export const RUNTIME_ASSET_ATTRIBUTE = "CumulativeOperatingHoursAttr";
export const RUNTIME_VIBRATION_ATTRIBUTE = "TotalRuntimeAttr";
export const RUNTIME_SERVICE_ATTRIBUTE = "ServiceRuntimeAttr";

export const ANALOG_INPUTS = [
  {
    attribute: "AI1EngineeringValueAttr",
    connectedAttribute: "AI1ConnectedAttr",
    minAttribute: "AI1EngineeringMinAttr",
    spanAttribute: "AI1EngineeringSpanAttr",
    modeAttribute: "AI1ModeAttr",
  },
  {
    attribute: "AI2EngineeringValueAttr",
    connectedAttribute: "AI2ConnectedAttr",
    minAttribute: "AI2EngineeringMinAttr",
    spanAttribute: "AI2EngineeringSpanAttr",
    modeAttribute: "AI2ModeAttr",
  },
  {
    attribute: "AI3EngineeringValueAttr",
    connectedAttribute: "AI3ConnectedAttr",
    minAttribute: "AI3EngineeringMinAttr",
    spanAttribute: "AI3EngineeringSpanAttr",
    modeAttribute: "AI3ModeAttr",
  },
  {
    attribute: "AI4EngineeringValueAttr",
    connectedAttribute: "AI4ConnectedAttr",
    minAttribute: "AI4EngineeringMinAttr",
    spanAttribute: "AI4EngineeringSpanAttr",
    modeAttribute: "AI4ModeAttr",
  },
  {
    attribute: "AI5EngineeringValueAttr",
    connectedAttribute: "AI5ConnectedAttr",
    minAttribute: "AI5EngineeringMinAttr",
    spanAttribute: "AI5EngineeringSpanAttr",
    modeAttribute: "AI5ModeAttr",
  },
  {
    attribute: "AI6EngineeringValueAttr",
    connectedAttribute: "AI6ConnectedAttr",
    minAttribute: "AI6EngineeringMinAttr",
    spanAttribute: "AI6EngineeringSpanAttr",
    modeAttribute: "AI6ModeAttr",
  },
  {
    attribute: "AI7EngineeringValueAttr",
    connectedAttribute: "AI7ConnectedAttr",
    minAttribute: "AI7EngineeringMinAttr",
    spanAttribute: "AI7EngineeringSpanAttr",
    modeAttribute: "AI7ModeAttr",
  },
  {
    attribute: "AI8EngineeringValueAttr",
    connectedAttribute: "AI8ConnectedAttr",
    minAttribute: "AI8EngineeringMinAttr",
    spanAttribute: "AI8EngineeringSpanAttr",
    modeAttribute: "AI8ModeAttr",
  },
];

export const DIGITAL_INPUTS = [
  {
    stateAttribute: "DI1StateAttr",
    flowAttribute: "DI1FlowAttr",
    accumulationAttribute: "DI1AccumulationAttr",
    modeAttribute: "DI1ModeAttr",
    kFactorAttribute: "DI1KFactorAttr",
    offsetAttribute: "DI1OffsetAttr",
    debounceAttribute: "DI1DebounceAttr",
    unitsPerPulseAttribute: "DI1UnitsPerPulseAttr",
  },
  {
    stateAttribute: "DI2StateAttr",
    flowAttribute: "DI2FlowAttr",
    accumulationAttribute: "DI2AccumulationAttr",
    modeAttribute: "DI2ModeAttr",
    kFactorAttribute: "DI2KFactorAttr",
    offsetAttribute: "DI2OffsetAttr",
    debounceAttribute: "DI2DebounceAttr",
    unitsPerPulseAttribute: "DI2UnitsPerPulseAttr",
  },
  {
    stateAttribute: "DI3StateAttr",
    flowAttribute: "DI3FlowAttr",
    accumulationAttribute: "DI3AccumulationAttr",
    modeAttribute: "DI3ModeAttr",
    kFactorAttribute: "DI3KFactorAttr",
    offsetAttribute: "DI3OffsetAttr",
    debounceAttribute: "DI3DebounceAttr",
    unitsPerPulseAttribute: "DI3UnitsPerPulseAttr",
  },
  {
    stateAttribute: "DI4StateAttr",
    flowAttribute: "DI4FlowAttr",
    accumulationAttribute: "DI4AccumulationAttr",
    modeAttribute: "DI4ModeAttr",
    kFactorAttribute: "DI4KFactorAttr",
    offsetAttribute: "DI4OffsetAttr",
    debounceAttribute: "DI4DebounceAttr",
    unitsPerPulseAttribute: "DI4UnitsPerPulseAttr",
  },
];

export const LOW_FLOAT_ENGAGED = "LowFloatEngagedAttr";
export const HIGH_FLOAT_ENGAGED = "HighFloatEngagedAttr";
export const ALARM_FLOAT_ENGAGED = "AlarmFloatEngagedAttr";

export const DTC_1_COUNT_ATTRIBUTE = "DTC1CountAttr";
export const DTC_2_COUNT_ATTRIBUTE = "DTC2CountAttr";
export const DTC_3_COUNT_ATTRIBUTE = "DTC3CountAttr";
export const DTC_4_COUNT_ATTRIBUTE = "DTC4CountAttr";
export const DTC_5_COUNT_ATTRIBUTE = "DTC5CountAttr";
export const DTC_1_CODE_ATTRIBUTE = "DTC1CodeAttr";
export const DTC_2_CODE_ATTRIBUTE = "DTC2CodeAttr";
export const DTC_3_CODE_ATTRIBUTE = "DTC3CodeAttr";
export const DTC_4_CODE_ATTRIBUTE = "DTC4CodeAttr";
export const DTC_5_CODE_ATTRIBUTE = "DTC5CodeAttr";
export const DTC_1_DESCRIPTION_ATTRIBUTE = "DTC1DescriptionAttr";
export const DTC_2_DESCRIPTION_ATTRIBUTE = "DTC1DescriptionAttr";
export const DTC_3_DESCRIPTION_ATTRIBUTE = "DTC1DescriptionAttr";
export const DTC_4_DESCRIPTION_ATTRIBUTE = "DTC1DescriptionAttr";
export const DTC_5_DESCRIPTION_ATTRIBUTE = "DTC1DescriptionAttr";
